module.exports = __webpack_public_path__ + "basicImage.png?dcba6a02dad215526bc6eb93ee6b2468";